import { BaseDto } from '@greco/util-dto';
export class UpdateStationsDto extends BaseDto {
  title?: string;
  communityId!: string;
  checkInBookings?: boolean;
}
